export interface Delivery {
  deliveryId: string;
  client: string;
  name: string;
  message: string;
  approvedFiles: string | null;
  rejectedFiles: string | null;
  deliveryDate: string;
}

export interface CreateDeliveryRequest {
  deliveryId: string;
  client: string;
  name: string;
  message: string;
  approvedFiles: string | null;
  rejectedFiles: string | null;
  deliveryDate: string;
}

export interface DeliveryPreview {
  deliveryId: string;
  name: string;
  clientId: string;
  deliveryDate: string;
}

export interface DeliveryLink {
  deliveryId: string;
  url: string;
}

export interface DeliveryResendRequest {
  deliveryId: string;
  message: string | null;
}

export interface Resource {
  resourceId: string | null;
  name: string;
  extension: string;
  size: string;
}

export function DeliveryActions() {
  function deliveryInfo(
    deliveryId: string,
    client: string,
    name: string,
    message: string,
    approvedFiles: string | null,
    rejectedFiles: string | null,
    deliveryDate: string
  ): Delivery {
    return {
      deliveryId: deliveryId,
      client: client,
      name: name,
      message: message,
      approvedFiles: approvedFiles,
      rejectedFiles: rejectedFiles,
      deliveryDate: deliveryDate
    };
  }

  function createDeliveryRequest(
    deliveryId: string,
    client: string,
    name: string,
    message: string,
    approvedFiles: string | null,
    rejectedFiles: string | null,
    deliveryDate: string
  ): Delivery {
    return {
      deliveryId: deliveryId,
      client: client,
      name: name,
      message: message,
      approvedFiles: approvedFiles,
      rejectedFiles: rejectedFiles,
      deliveryDate: deliveryDate
    };
  }

  function deliveryPreview(
    deliveryId: string,
    name: string,
    clientId: string,
    deliveryDate: string
  ): DeliveryPreview {
    return {
      deliveryId: deliveryId,
      name: name,
      clientId: clientId,
      deliveryDate: deliveryDate
    };
  }

  function deliveryLink(
    deliveryId: string,
    url: string
  ): DeliveryLink {
    return {
      deliveryId: deliveryId,
      url: url
    };
  }

  function deliveryResendRequest(
    deliveryId: string,
    message: string | null
  ): DeliveryResendRequest {
    return {
      deliveryId: deliveryId,
      message: message
    };
  }

  function resource(
    resourceId: string | null,
    name: string,
    extension: string,
    size: string
  ): Resource {
    return {
      resourceId: resourceId,
      name: name,
      extension: extension,
      size: size
    };
  }

  function deserialize(object: string): Delivery[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.map((delivery: Delivery) => {
      return deliveryInfo(
        delivery.deliveryId,
        delivery.client,
        delivery.name,
        delivery.message,
        delivery.approvedFiles,
        delivery.rejectedFiles,
        delivery.deliveryDate
      );
    });
  }

  function deserializeObject(object: string): Delivery {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return deliveryInfo(
      parseResponse.deliveryId,
      parseResponse.client,
      parseResponse.name,
      parseResponse.message,
      parseResponse.approvedFiles,
      parseResponse.rejectedFiles,
      parseResponse.deliveryDate
    );
  }

  return {
    deliveryInfo,
    createDeliveryRequest,
    deliveryPreview,
    deliveryLink,
    deliveryResendRequest,
    resource,
    deserialize,
    deserializeObject,
  };
}
